import React from 'react';
import { Pagination } from 'react-admin';

export const PaginationIfAvailable = (props) => {
  return props.total ? (<Pagination
    {...props}
    rowsPerPageOptions={[10, 25, 50, 100]}
                        />) : null;
};
